import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const HeaderStyled = styled.div<T>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1em 2em;
  /* Frosted background */
  backdrop-filter: blur(80px);
  -webkit-backdrop-filter: blur(80px);

  h2 {
    font-size: 2em;
    font-weight: 500;
    line-height: 0.8em;
    letter-spacing: 0;
    text-align: left;
  }

  .close-modal {
    position: absolute;
    right: 35px;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
